import { Link } from "react-router-dom";
import {
  CORPORATE_CASES,
  CORPORATE_COMPANY,
  CORPORATE_NEWS,
  CORPORATE_SOLUTIONS,
  CORPORATE_STATS,
  CORPORATE_VALUES,
} from "../CorporatePortalContent";

export default function CorporateHomePage() {
  return (
    <>
      <section className="corporate-hero">
        <div className="corporate-hero-inner">
          <div className="corporate-hero-badge">{CORPORATE_COMPANY.fullName}</div>
          <h1 className="corporate-hero-title">{CORPORATE_COMPANY.slogan}</h1>
          <p className="corporate-hero-subtitle">{CORPORATE_COMPANY.intro}</p>
          <div className="corporate-hero-actions">
            <Link to="/solutions" className="corporate-btn corporate-btn-primary">
              了解解决方案
            </Link>
            <Link to="/contact" className="corporate-btn corporate-btn-outline">
              预约咨询
            </Link>
          </div>
        </div>
      </section>

      <div className="corporate-page">
        <div className="corporate-stats-grid">
          {CORPORATE_STATS.map((item) => (
            <div key={item.label} className="corporate-stat-card">
              <div className="corporate-stat-value">{item.value}</div>
              <div className="corporate-stat-label">{item.label}</div>
            </div>
          ))}
        </div>

        <section className="corporate-section">
          <h2 className="corporate-section-title">核心能力</h2>
          <p className="corporate-section-desc">
            从数据治理、模型训练到业务系统对接，我们提供可度量、可复制的 AI 落地能力。
          </p>
          <div className="corporate-card-grid corporate-card-grid-3">
            {CORPORATE_VALUES.map((item) => (
              <div key={item.title} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">解决方案</h2>
          <p className="corporate-section-desc">覆盖制造、零售、金融、能源等主流传统行业场景。</p>
          <div className="corporate-card-grid">
            {CORPORATE_SOLUTIONS.slice(0, 4).map((item) => (
              <div key={item.id} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.summary}</p>
                <div className="corporate-tag-list">
                  {item.industries.map((tag) => (
                    <span key={tag} className="corporate-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24 }}>
            <Link to="/solutions" className="corporate-btn corporate-btn-primary">
              查看全部方案
            </Link>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">客户成果</h2>
          <p className="corporate-section-desc">以业务指标验收，帮助客户实现可量化的数字化收益。</p>
          <div className="corporate-card-grid">
            {CORPORATE_CASES.slice(0, 2).map((item) => (
              <div key={item.id} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.client} · {item.industry}</p>
                <p className="corporate-card-text" style={{ marginTop: 12, color: "#0b3d91" }}>
                  {item.result}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 24 }}>
            <Link to="/cases" className="corporate-btn corporate-btn-primary">
              更多成功案例
            </Link>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">新闻动态</h2>
          <div className="corporate-news-list">
            {CORPORATE_NEWS.slice(0, 3).map((item) => (
              <Link key={item.id} to={`/news/${item.id}`} className="corporate-news-item">
                <div className="corporate-news-meta">
                  <span>{item.date}</span>
                  <span>{item.category}</span>
                </div>
                <h3 className="corporate-news-title">{item.title}</h3>
                <p className="corporate-news-summary">{item.summary}</p>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
